import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { IoMdCalendar, IoMdDoneAll, IoMdDownload } from "react-icons/io";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import getExcel from "../../../_services/ExcelUtility";
// Local imports
import ReactTable from "../../../components/FilterTable";
import { _HttpServices } from "../../../_services/_HttpServices";
import Loader from '../../../components/Loader';
import { Footer } from "../../../components/Footer";
const ProductsPage = () => {
  const fileName = 'Products';
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const columns = [
    {
      Header: "SKU",
      accessor: "SKU",
      filter: "SKU",
      sortType: "basic",
    },
    {
      Header: "NDC",
      accessor: "NDC",
      filter: "NDC",
      sortType: "basic",
    },
    {
      Header: "Product Name",
      accessor: "ProductName",
      filter: "ProductName",
      sortType: "basic",
      width:200
    }, {
      Header: 'Price ($)',
      accessor: 'Price',
      filter: 'Price',
      sortType: 'basic',
      width:100,
    }, {
      Header: 'Minimum Price ($)',
      accessor: 'MinPrice',
      filter: 'MinPrice',
      sortType: 'basic',
      width:100,
    },
    {
      Header: "Available Qty",
      accessor: "AvaliableQuantity",
      filter: "AvaliableQuantity",
      sortType: "basic",
      width:120,
    },
    {
      Header: "Manufacturer",
      accessor: "Manufacturer",
      filter: "Manufacturer",
      sortType: "basic",
    },
    {
      Header: "Size",
      accessor: "size",
      filter: "size",
      sortType: "basic",
    },
    {
      Header: "Unit Of Measure",
      accessor: "unitOfMeasure",
      filter: "unitOfMeasure",
      sortType: "basic",
    }
  ];
  

  useEffect(() => {
      getProducts()
  }, [])
  async function getProducts() {
    setLoading(true)
    if(!localStorage.getItem("products")) {
      await _HttpServices
      .getData("Api/Product/Allproducts")
      .then((data) => {
        const productResult = data.data
       
        if (productResult.length > 0) {
          productResult.map((res) => {
            res.MinPrice = res.MinPrice == null ? "$0.00" : "$" + (res.MinPrice * 1).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            res.Price = res.Price == null ? "$0.00" : "$" + (res.Price * 1).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
          })
        }
        setLoading(false)
        setProducts(productResult)
        localStorage.setItem("products",JSON.stringify(productResult))
      })
      .catch((e) => {
        setLoading(false)
        console.log(e)
        setHasError(true)

      });  
    } else {
      let product = localStorage.getItem("products")
      if(product === null) {
        product = []
      }
      setProducts(JSON.parse(product));
      setLoading(false)
    }
  }

  return (
    <section className="content">
      <div className="page-title">
        <h2 className="h2">Products</h2>
        {products.length > 0 ? <Button type="submit" onClick={() => getExcel(columns,products,fileName)}><IoMdDownload className="icon btn-icon" />Download Excel</Button> : null}
      </div>

      <Row>
        <Col md={12}>
          <div className="card pt-2 mb-4" hidden={true}>
            <div className="card-body">
              <Form>
                <Row>
                  <Col md={3}>
                    <Form.Group>
                      <div className="date-picker ungroup-date-picker pos-rl">
                        <Form.Label htmlFor="StartDate">
                          Start Date
                        </Form.Label>
                        <IoMdCalendar className="icon date-icon" />
                        <DatePicker
                          selected={startDate}
                          onChange={(date) => setStartDate(date)}
                        />
                      </div>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group>
                      <div className="date-picker ungroup-date-picker pos-rl">
                        <Form.Label htmlFor="EndDate">
                          End Date
                        </Form.Label>
                        <IoMdCalendar className="icon date-icon" />
                        <DatePicker
                          selected={endDate}
                          onChange={(date) => setEndDate(date)}
                        />
                      </div>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mt-1">
                      <Button type="submit" className="mt-4" disabled>
                        <IoMdDoneAll className="icon btn-icon" />
                        Submit
                      </Button>
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            </div>
          </div>

          <div className="card pt-2">
            <div className="card-body">
              <div className="inventory-grid">
              {hasError ? <p>Error occurred. Unable to load products.</p> :
                <Fragment>
                  {loading ? <Loader /> : products.length > 0 ? (
                    <ReactTable columns={columns} data={products} defaultPageSize={10} />
                  ) : (
                      <div className="no-data">No data found.</div>
                    )}
                </Fragment>
              }
              </div>
            </div>
          </div>
        </Col>
      </Row>
            
      <Footer />
    </section>
  );
};

export default ProductsPage;
